<template>
  <div class="">
    <div class="hero-background"></div>
    <div class="gradient-overlay"></div>
    <div class="row d-flex align-items-center justify-content-center vh-100">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
        <Card class="bg-white verify-otp-card shadow-lg">
          <div class="card-content p-4">
            <div class="text-center mb-4">
              <img src="../../../public/logo.png" width="100px" alt="logo" class="logo-animation">
              <h2 class="verify-otp-title mt-4 mb-1">Verify OTP</h2>
              <p class="text-muted">Enter the OTP code sent to your email</p>
            </div>

            <div class="mt-5">
              <form @submit.prevent="verifySubmit">
                <UInput
                    placeholder="Enter OTP"
                    type="number"
                    size="lg"
                    autofocus
                    v-model="user.otp"
                    class="mb-3">
                  <template #label>OTP Code</template>
                </UInput>

                <div class="d-flex justify-content-start mb-4">
                  <Button
                      type="outline-secondary"
                      size="sm"
                      class="otpBtn"
                      :disabled="otpButtonDisabled"
                      @click="resendOTP">
                    {{ otpButtonText }}
                  </Button>
                </div>

                <div class="d-flex justify-content-between mt-4">
                  <Button
                      type="outline-primary"
                      size="lg"
                      rounded
                      @click="$router.go(-1)">
                    Back
                  </Button>
                  <button
                      class="btn btn-primary btn-lg rounded rounded-2"
                      :class="loading ? 'disabled' : ''"
                  >
                    <span v-if="!loading">Verify OTP</span>
                    <Spinner v-else size="20" stroke="#ffffff" spinner-class="mt-1"/>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import authService from "@/api/authService";

export default {
  name: 'VerifyOtp',
  data() {
    return {
      loading: false,
      email: sessionStorage.getItem('email'),
      otpButtonDisabled: false,
      otpButtonText: 'Resend OTP',
      otpTimer: null
    }
  },

  methods: {
    async verifySubmit() {
      this.loading = true;
      await authService.verifyOTP(this.user);
      this.loading = false;
    },
    async resendOTP() {
      if (this.otpButtonDisabled) return;

      let response = await authService.requestOTP({email: this.email});
      if (response) {
        this.startOtpTimer();
      }
    },
    startOtpTimer() {
      this.otpButtonDisabled = true;
      let seconds = Number(sessionStorage.getItem('otp')) || 60;

      // Clear any existing timer
      if (this.otpTimer) {
        clearInterval(this.otpTimer);
      }

      this.otpTimer = setInterval(() => {
        if (seconds <= 0) {
          clearInterval(this.otpTimer);
          this.otpButtonDisabled = false;
          this.otpButtonText = 'Resend OTP';
          sessionStorage.removeItem('otp');
          return;
        }

        seconds--;
        sessionStorage.setItem('otp', seconds.toString());
        this.otpButtonText = `Resend. Wait, ${seconds} secs`;
      }, 1000);
    }
  },

  mounted() {
    // Check if there's an existing timer
    const remainingTime = Number(sessionStorage.getItem('otp'));
    if (remainingTime > 0) {
      this.startOtpTimer();
    }
  },

  beforeUnmount() {
    // Clear timer when component is destroyed
    if (this.otpTimer) {
      clearInterval(this.otpTimer);
    }
  },

  computed: {
    user() {
      return {
        email: sessionStorage.getItem('email'),
        otp: process.env.NODE_ENV === 'development' ? '123456' : ''
      }
    }
  }
}
</script>

<style scoped>
.verify-otp-container {
  min-height: 100vh;
  position: relative;
}

/* Hero Background */
.hero-background {
  background-image: url('@/assets/img/backgrounds/background.webp');
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  z-index: -2;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0.5) 5%, rgba(0,0,0,0.8) 100%);
  z-index: -1;
}

.verify-otp-card {
  border: none;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.verify-otp-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
}

.verify-otp-title {
  font-weight: 700;
  color: #333;
}

.logo-animation {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.card-content {
  padding: 2rem;
}

.otpBtn {
  transition: all 0.3s ease;
}

.otpBtn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
